import { all } from 'redux-saga/effects';
import authSagas from './auth/redux/sagas';
import createGroupSagas from './createBasket/redux/sagas';
import groupsSagas from './baskets/redux/sagas';
import groupDetailsSagas from './basketDetails/redux/sagas';
import profileSagas from './profile/redux/sagas';
import updateGroupSagas from './updateBasket/redux/sagas';
import basketSagas from './basket/redux/sagas';
import ordersSagas from './orderHistory/redux/sagas';
// import productSagas from './products/redux/sagas';
import recipesSagas from './recipes/redux/sagas';
import recipeSagas from './recipe/redux/sagas';
import mealSagas from './Meal/redux/sagas';
import partnerSagas from './marketplace/redux/sagas';
import sellersSagas from './sellers/redux/sagas';
import productSagas from './product/redux/sagas';

export default function* root() {
  yield all([
    authSagas(),
    groupsSagas(),
    groupDetailsSagas(),
    createGroupSagas(),
    profileSagas(),
    updateGroupSagas(),
    basketSagas(),
    ordersSagas(),
    productSagas(),
    recipesSagas(),
    recipeSagas(),
    mealSagas(),
    partnerSagas(),
    sellersSagas(),
    productSagas(),
  ]);
}
